import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import LandingPage from "@/pages/LandingPage";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";

export default function HomeRoute() {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0b0a10]">
        <Loader2 className="w-7 h-7 text-violet-400 animate-spin" />
      </div>
    );
  }
  if (!user) return <LandingPage />;
  return (
    <Layout>
      <HomePage />
    </Layout>
  );
}
